import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";

type Props = {
    isDisabled: boolean;
    onSubmit: () => void;
    size?: 'md' | 'sm' | 'lg',
};

const OrderButton = ({ isDisabled, onSubmit, size = 'md' }: Props) => {
    const { t } = useGranite();

    return (
        <Button
            test="orderButton-button-submit"
            color="secondary"
            disabled={isDisabled}
            onClick={onSubmit}
            type="button"
            size={size}
            fullWidth
        >
            <span className="d-none d-md-block">
                {t("ecommerce.button.order")}{" "}
                <i className="la-md las la-angle-right"></i>
            </span>
            <span className="d-md-none">
                {t("ecommerce.buttonMobile.order")}{" "}
                <i className="la-md las la-angle-right"></i>
            </span>
        </Button>
    );
};

export default OrderButton;
